"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckable = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCheckable = _styledComponents.default.div.withConfig({
  displayName: "Checkablestyles__StyledCheckable",
  componentId: "oej5ln-0"
})(["line-height:1rem;.c-checkable-input{position:absolute;opacity:0;cursor:pointer;height:1rem;width:1rem;}.c-checkable-input ~ .c-checkable-unchecked{display:inline-block;}.c-checkable-input:checked ~ .c-checkable-unchecked{display:none;}.c-checkable-input ~ .c-checkable-checked{display:none;}.c-checkable-input:checked ~ .c-checkable-checked{display:inline-block;}.c-checkable-icon-wrapper{line-height:1rem;}"]);

exports.StyledCheckable = StyledCheckable;